import React, { Dispatch, SetStateAction, useRef, useState } from 'react';
import { FamlaServices } from '../../services';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../stores';
import { Spiner } from '../../components';
import { iUser } from '../../components/type';

interface DemoteAdminToUserModalProps {
    targetUserId: string | undefined;
    companyId: string;
    setUsers: Dispatch<SetStateAction<iUser[]>> | undefined;
    users: iUser[];
    listType: string | undefined
}

const DemoteAdminToUserModal: React.FC<DemoteAdminToUserModalProps> = ({ targetUserId, companyId, setUsers, users, listType }) => {
    const auth = useAppSelector(state => state.auth);
    const { t } = useTranslation();
    const closeRef = useRef<HTMLButtonElement>(null);
    const [isSubmit, setIsSubmit] = useState(false);

    const [alert, setAlert] = useState({
        isActive: false,
        type: "",
        message: ""
    });

    const handleSubmit = async (event: React.SyntheticEvent) => {
        event.preventDefault();
        setIsSubmit(true);

        const endpoint = `/company/admin/remove/${companyId}/${targetUserId}`;
        const data = await FamlaServices("api_host", endpoint, "PUT", "", auth.access_token);

        if (data.status === 200) {
            closeRef.current && closeRef.current.click();
            setAlert({ isActive: false, type: '', message: "" });
            if (setUsers) {
                if (listType === "ADMIN") {
                    setUsers(users.filter((user: iUser) => user._id !== targetUserId));
                } else {
                    setUsers(users.filter((user: iUser) => user._id !== targetUserId));
                }
            }
            // setAlert({ isActive: true, type: 'success', message: t('dashboard.successDemotion') });

        } else if (data.status === 401) {
            setAlert({ isActive: true, type: 'warning', message: t('navigation.youAreNotAuthorizedToPerformThisAction') });
            setIsSubmit(false);
        } else if (data.status === 400) {
            setAlert({ isActive: true, type: 'warning', message: t('dashboard.rootUserCannotBeRemoved') });
            setIsSubmit(false);
        } else if (data.status === 404) {
            setAlert({ isActive: true, type: 'warning', message: t("dashboard.companyNotFound") });
            setIsSubmit(false);
        } else {
            setAlert({ isActive: true, type: 'danger', message: t('navigation.anErrorOcured') });
            setIsSubmit(false);
        }
        setIsSubmit(false);
    };

    return (
        <div className="modal fade" id={`demoteAdminToUser${targetUserId}`} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content bg-dark">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">{t('dashboard.demoteFromAdmin')}</h5>
                        <button type="button" className="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            {alert.isActive &&
                                <div className={` text-wrap alert alert-${alert.type}`} role="alert">
                                    {alert.message}
                                </div>
                            }
                            <p className="mb-3 text-wrap">{t('dashboard.confirmUserDemotion')}</p>
                            <div className="modal-footer px-0 mx-0">
                                <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal" ref={closeRef}>{t('words.close')}</button>
                                <button type="submit" className="btn btn-primary btn-sm">
                                    {isSubmit ?
                                        <Spiner className='spinner-grow-sm text-light' />
                                        :
                                        <span>{t('words.demote')}</span>
                                    }
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DemoteAdminToUserModal;
